import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Select,
  Button,
  Row,
  Col,
  notification,
} from "antd";
import ReactQuill from "react-quill";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { InfoCircleOutlined, CheckCircleOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { addeditprize,prizeList } from "../../../controllers/V1/cms/campaignController";
import "react-quill/dist/quill.snow.css";
import "react-datepicker/dist/react-datepicker.css";
import { ASSETS_BASE_URL } from "../../../config/constants";
import UploadImage from '../products/UploadImge'
import { Image } from 'antd';
import Loading from "../../../components/Loading/LoadingEffect";

const { Option } = Select;

const PrizeAddEdit = () => {
  const location = useLocation();
  const state = location.state; // State for edit mode

  const [isLoading, setIsLoading] = useState(true);

  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [listData,setListData]=useState('')
  const [initialValues, setInitialValues] = useState({enable_title:"N", enable_straight_prize_heading: "Y", 
    enable_rumble_prize_heading: "Y",
    enable_chance_prize_heading: "Y",});
  const [showNumberRangePrefix, setShowNumberRangePrefix] = useState(true);
  // Set initial form values for edit mode
  const [ADDEDITDATA, setAddEditData] = useState(state || []);
  const [isOpenUpload, setIsOpenUpload] = useState(false);
  const [childData, setChildData] = useState('');
  const handleUploadImage = () => setIsOpenUpload(!isOpenUpload);

  const handleChildData = (data) => {
    setChildData(data);
    if (data?._id) {
      setAddEditData((prevState) => ({
        ...prevState,
        image: data?.url || '',
      }));
      form.setFieldsValue({ image: data?.url || '' }); // Update the form's image field
    }
  };
  
    const getPrizeList = async () => {
      try {
        setListData([]);
        const options = {
          type: "single",
          condition: {
            'campaign_data':state?._id
          },
        };
        const listData = await prizeList(options);
        if (listData.status === true) {
            setListData(listData?.result);
            setInitialValues(listData?.result)
        }
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
      }
    }; //End
  
  const handleSubmit = async (values) => {
    try{
    const formattedValues = {
      ...values,
      campaign_id: state?._id || ADDEDITDATA?._id || undefined, // Pass ID in edit mode
      ...(ADDEDITDATA?.prizeData && { editId: ADDEDITDATA?.prizeData || "" } ),
      image: childData?.url || state?.image || "N/A", // Handle image

    };
      const res = await addeditprize(formattedValues);
      if (res.status === true) {
        notification.success({
          message: "Success",
          description: "Data successfully added/updated.",
          icon: <CheckCircleOutlined style={{ color: "green" }} />,
          duration: 2,
        });
        navigate("/campaign/list");
      } else {
        notification.error({
          message: "Error",
          description: res.message,
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
          duration: 2,
        });
      }
    } catch (error) {
      console.error("Error during submission:", error);
    }
  };
  

  useEffect(() => {
    form.setFieldsValue(initialValues); // Populate form fields
  }, [initialValues, form]);

const handleValuesChange = (changedValues, allValues) => {
    if ("enable_title" in changedValues) {
      if (changedValues.enable_title === "Y") {
        setInitialValues((prev) => ({
          ...prev,
          enable_straight_prize_heading: "N",
          enable_rumble_prize_heading: "N",
          enable_chance_prize_heading: "N",
        }));
        form.setFieldsValue({
          straight_super_prize: undefined,
          rumble_super_prize: undefined,
          chance_super_prize: undefined,
        });
      } else {
        setInitialValues((prev) => ({
          ...prev,
          enable_straight_prize_heading: "Y",
          enable_rumble_prize_heading: "Y",
          enable_chance_prize_heading: "Y",
        }));
      }
    } else {
      if (
        "enable_straight_prize_heading" in changedValues &&
        changedValues.enable_straight_prize_heading === "N"
      ) {
        form.setFieldsValue({ straight_super_prize: undefined });
      }
      if (
        "enable_rumble_prize_heading" in changedValues &&
        changedValues.enable_rumble_prize_heading === "N"
      ) {
        form.setFieldsValue({ rumble_super_prize: undefined });
      }
      if (
        "enable_chance_prize_heading" in changedValues &&
        changedValues.enable_chance_prize_heading === "N"
      ) {
        form.setFieldsValue({ chance_super_prize: undefined });
      }

      setInitialValues((prev) => ({
        ...prev,
        ...changedValues,
      }));
    }
  };
  
  useEffect(() => {
    if (state?.enable_number_range_prefix === "N") {
      setShowNumberRangePrefix(false);
    }
    document.title = `Crown King || campaign's prize ${listData?._id ? "edit" : "add"}`;
    getPrizeList()
  }, [state]);
  

  return (
    <div className="container-fluid">
      <div className="Inventory_edit_page_main_div">
        <h5 className="inventory_edit_page_heading">
          {listData?._id ? "Edit" : "Add"} Campaign Prize
        </h5>
        <Link to="/campaign/list">
          <Button type="secondary">
            <ArrowLeftOutlined /> Back
          </Button>
        </Link>
      </div>

      <div className="card shadow mb-4 dataBase_table_Add_Data">
        <div style={{ padding: "20px" }}>
        <Form
  form={form}
  layout="vertical"
  onFinish={handleSubmit}
  initialValues={initialValues}
  onValuesChange={handleValuesChange}
>
  {/* Campaign Details */}
  {/* <input type="hidden" name="editId" id="editId" value={ADDEDITDATA?.prizeData || ""} /> */}
  {/* <input type="hidden" name="campaign_id" id="campaign_id" value={ADDEDITDATA?._id || ""} /> */}
  <Row gutter={16}>
    <Col span={12}>
      <Form.Item
        label="Enable Title"
        name="enable_title"
        value={"N"}
        rules={[{ required: true, message: "Enable Title  is required!" }]}
      >
            <Select>
          <Option value="Y">Yes</Option>
          <Option value="N">No</Option>
        </Select>
      </Form.Item>
    </Col>
    <Col span={12}>
      <Form.Item
        label="Title"
        name="title"
        rules={[{ required: true, message: "Title is required!" }]}
      >
        <Input />
      </Form.Item>
    </Col>
  </Row>

  <Row gutter={16}>
    <Col span={24}>
      <Form.Item
        label="Description"
        name="description"
        rules={[{ required: true, message: "Description is required!" }]}
      >
        <ReactQuill />
      </Form.Item>
    </Col>
  </Row>

  {/* Image Upload */}
  <Row gutter={16}>
    <Col span={12}>
      <Form.Item
        label="Image"
        name="image"
        rules={[{ required: true, message: "Image is required!" }]}
      >
        <div>
          <button
            type="button"
            className="btn btn-light"
            onClick={handleUploadImage}
          >
            Select
          </button>
          <span>{childData?.url}</span>
          {state?._id && initialValues?.image && (
            <Image width={100} src={`${ASSETS_BASE_URL}${initialValues.image}`} />
          )}
        </div>
      </Form.Item>
    </Col>
  </Row>

  {/* Straight Prize Details */}
  <Row gutter={16}>
    <Col span={8}>
      <Form.Item
        label="Enable Straight Prize"
        name="enable_straight_prize_heading"
        rules={[{ required: true, message: "Required!" }]}
      >
        <Select>
          <Option value="Y">Yes</Option>
          <Option value="N">No</Option>
        </Select>
      </Form.Item>
    </Col>
    <Col span={8}>
      <Form.Item
        label="Straight Prize Heading"
        name="straight_prize_heading"
      >
        <Input name="straight_prize_heading" value={initialValues?.straight_prize_heading} />
      </Form.Item>
    </Col>
    <Col span={8}>
      <Form.Item
        label="Shared Straight Prizes"
        name="straight_shared_prize"
      >
   <Select mode="multiple" >
                    {[...Array(state?.lotto_type).keys()].map((index) => (
                      <Option key={`prize${index + 1}`} value={`Prize ${index + 1}`}>
                        Prize {index + 1}
                      </Option>
                    ))}
                  </Select>

      </Form.Item>
    </Col>
  </Row>
  {state?.enable_straight_prize_heading==='Y' || initialValues?.enable_straight_prize_heading==='Y'?
  <Row gutter={16}>
    {Array.from({ length: state?.lotto_type }).map((_, index) => (
      <Col span={8} key={`straight_prize${index + 1}`}>
        <Form.Item
          label={`Straight Prize ${index + 1}`}
          name={`straight_prize${index + 1}`}
        >
          <Input type="number" />
        </Form.Item>
      </Col>
    ))}
  </Row>
:""}
  {/* Repeat similar sections for Rumble and Chance Prizes */}
  <Row gutter={16}>
    <Col span={8}>
      <Form.Item
        label="Enable Rumble Prize"
        name="enable_rumble_prize_heading"
        rules={[{ required: true, message: "Required!" }]}
      >
        <Select>
          <Option value="Y">Yes</Option>
          <Option value="N">No</Option>
        </Select>
      </Form.Item>
    </Col>
    <Col span={8}>
      <Form.Item
        label="Rumble Prize Heading"
        name="rumble_prize_heading"
      >
        <Input />
      </Form.Item>
    </Col>
    <Col span={8}>
      <Form.Item
        label="Shared Rumble Prizes"
        name="rumble_shared_prize"
      >
         <Select mode="multiple">
                    {[...Array(state?.lotto_type).keys()].map((index) => (
                      <Option key={`prize${index + 1}`} value={`Prize ${index + 1}`}>
                        Prize {index + 1}
                      </Option>
                    ))}
                  </Select>
      </Form.Item>
    </Col>
  </Row>
  {state?.enable_rumble_prize_heading==='Y' || initialValues?.enable_rumble_prize_heading==='Y'  ?
  <Row gutter={16}>
    {Array.from({  length: state?.lotto_type  }).map((_, index) => (
      <Col span={8} key={`rumble_prize${index + 1}`}>
        <Form.Item
          label={`Rumble Prize ${index + 1}`}
          name={`rumble_prize${index + 1}`}
        >
          <Input type="number" />
        </Form.Item>
      </Col>
    ))}
  </Row>
:""}

  {/* Chance Prize Details */}
  <Row gutter={16}>
    <Col span={8}>
      <Form.Item
        label="Enable Chance Prize"
        name="enable_chance_prize_heading"
        rules={[{ required: true, message: "Required!" }]}
      >
        <Select>
          <Option value="Y">Yes</Option>
          <Option value="N">No</Option>
        </Select>
      </Form.Item>
    </Col>
    <Col span={8}>
      <Form.Item
        label="Chance Prize Heading"
        name="chance_prize_heading"
      >
        <Input />
      </Form.Item>
    </Col>
    <Col span={8}>
      <Form.Item
        label="Chance Shared Prizes"
        name="chance_shared_prize"
      >
          <Select mode="multiple">
                    {[...Array(state?.lotto_type).keys()].map((index) => (
                      <Option key={`prize${index + 1}`} value={`Prize ${index + 1}`}>
                        Prize {index + 1}
                      </Option>
                    ))}
                  </Select>
      </Form.Item>
    </Col>
  </Row>
  {initialValues?.enable_chance_prize_heading === 'Y'?
  <Row gutter={16}>
  {Array.from({ length: state?.lotto_type || 0 }).map((_, index) => (
    <Col span={8} key={`chance_prize${index + 1}`}>
      <Form.Item
        label={`Chance Prize ${index + 1}`}
        name={`chance_prize${index + 1}`}
      >
        <Input type="number" />
      </Form.Item>
    </Col>
  ))}
</Row>
:""}

  {state?.enable_super_ball === "Y" &&
  (initialValues?.enable_straight_prize_heading === "Y" ||
    initialValues?.enable_rumble_prize_heading === "Y" ||
    initialValues?.enable_chance_prize_heading === "Y") ? (
    <Row gutter={16}>
      {initialValues?.enable_straight_prize_heading === "Y" ? (
        <Col span={8}>
          <Form.Item
            label="Straight Super Prize"
            name="straight_super_prize"
            rules={[{ required: true, message: "Straight super prize is required!" }]}
          >
            <Input type="number" />
          </Form.Item>
        </Col>
      ) : null}
      {initialValues?.enable_rumble_prize_heading === "Y" ? (
        <Col span={8}>
          <Form.Item
            label="Rumble Super Prize"
            name="rumble_super_prize"
            rules={[{ required: true, message: "Rumble super prize is required!" }]}
          >
            <Input type="number" />
          </Form.Item>
        </Col>
      ) : null}
      {initialValues?.enable_chance_prize_heading === "Y" ? (
        <Col span={8}>
          <Form.Item
            label="Chance Super Prize"
            name="chance_super_prize"
            rules={[{ required: true, message: "Chance super prize is required!" }]}
          >
            <Input type="number" />
          </Form.Item>
        </Col>
      ) : null}
    </Row>
  ) : null}

  {/* Submit Button */}
  <div className="text-center">
    {/* <button type="submit" className="btn btn-primary">
      Save
    </button> */}
    <div class="verndor_dashboard_add_edit_button"><button type="submit" class="btn btn-primary inventory_save_button">Save</button></div>
  </div>
</Form>

        </div>
      </div>   
       <UploadImage openUpload={isOpenUpload} toggleUploadOpen={handleUploadImage} onSendData={handleChildData}/>
       <Loading isLoading={isLoading} />
    </div>

  );
};

export default PrizeAddEdit;
